<div *ngIf="latestNotification?.reason" class="last-notification">
  <div class="last-notification__header tw-flex">
    <ui-svg-icon [name]="iconNameList.AlertWarningFilled" class="last-notification__icon"></ui-svg-icon>
    <span class="last-notification__header-title tw-justify-center tw-items-center" cropText>
      {{ 'deliveryNote.overview.mainInfo.latestNotification' | translate }}
    </span>
  </div>
  <span class="last-notification__description" cropText>
    {{ latestNotification?.reason }}
  </span>
  <span class="last-notification__time">
    <ui-date-with-timezone
      *ngIf="isTimezoneAvailable; else timezoneNotAvailable"
      class="cropped"
      [localDate]="latestNotification?.actualArrivalTime"
    ></ui-date-with-timezone>
    <ng-template #timezoneNotAvailable>
      <span class="last-notification__time" cropText>
        {{ latestNotification?.actualArrivalTime | locale }}
      </span>
    </ng-template>
  </span>
</div>
